import { Table } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from '../../services/clientService';
import { ZorbaSelect } from '../../components/forms';
import { getReportData } from '../../reducer/BuyersReport/actions';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { daysOptions, getTableColumns } from './constants';

import './index.scss';

const InstitutionalBuyersReportPage = () => {
  const tableScroll = {
    scrollToFirstRowOnChange: true,
    x: isMobile() ? true : 'max-content',
  };

  useDocumentTitle(`Institutional Buyers report`);
  const dispatch = useDispatch();
  const { data, isLoading } = useSelector(
    ({ BuyersReportReducer }) => BuyersReportReducer,
  );
  const [selectedDays, setSelectedDays] = useState(30);

  useEffect(() => {
    dispatch(getReportData({ daysSince: selectedDays }));
  }, [selectedDays]);

  const pagination = {
    position: ['bottomRight'],
    pageSize: 50,
  };

  return (
    <div className="buyers-report-page">
      <div className="buyers-report-filter">
        
        <ZorbaSelect
          options={daysOptions}
          value={selectedDays}
          onChange={(e) => setSelectedDays(e)}
          className="buyers-report-select"
          disabled={isLoading}
        />
      </div>
      <Table
        rowKey="_id"
        className="buyer-report-table"
        dataSource={data}
        columns={getTableColumns()}
        loading={isLoading}
        pagination={pagination}
        title={() => `Institutional Buyers (${data?.length || 0})`}
        scroll={tableScroll}
      />
    </div>
  );
};

export default InstitutionalBuyersReportPage;
